import React, {useState,useEffect,createContext} from "react";
import {firestore} from '../Utils/config';
import { useHistory } from "react-router-dom";

export const MeetingContext = createContext();

const MeetingProvider = (props) => {
    const [mettingInfo,setMeetinginfo] = useState(null);
    const history = useHistory();
    useEffect(() => {
        const firebaseMeetingRef = firestore.collection("meetings")
        .doc("mId_"+history.location.pathname.split("/")[2]);

        const unsubscribeMeetingInfo = firebaseMeetingRef.onSnapshot((doc) => {
            // do stuff with the data
            setMeetinginfo(doc.data());
        });

        return () => {
            unsubscribeMeetingInfo();
        }
        
    },[])

    return (
        <MeetingContext.Provider value={mettingInfo}>
            {props.children}
        </MeetingContext.Provider>
    );
}

export default MeetingProvider;